import React from 'react';
import cn from 'classnames';

import Stack from '../../Stack';
import Typography from '../../Typography';
import BaseMenuItem from '../BaseMenuItem';
import { renderMenuItemIcon } from '../renderers';
import { LARGE_MENU_ITEM_CLASSES as classes, largeMenuItemStyles } from './styles';
import { LargeMenuItemProps } from './types';

const LargeMenuItem: React.FC<React.PropsWithChildren<LargeMenuItemProps>> = (props) => {
  const {
    as,
    asProps,
    classes: classesProp,
    className,
    description,
    label,
    startIcon,
    StartIcon,
    ...rest
  } = props;

  return (
    <BaseMenuItem
      button
      component={as}
      {...asProps}
      className={cn(classes.root, classesProp?.root, className)}
      {...rest}>
      {renderMenuItemIcon({ classes: classes.startIcon, icon: startIcon, Icon: StartIcon })}
      <Stack direction="col" gapY={2}>
        <Typography
          className={cn(classes.label, classesProp?.label)}
          color="text-text-primary"
          variant="label-02">
          {label}
        </Typography>
        <Typography
          className={cn(classes.description, classesProp?.description)}
          color="text-text-secondary"
          variant="body-short-03">
          {description}
        </Typography>
      </Stack>
    </BaseMenuItem>
  );
};

export { LargeMenuItemProps, largeMenuItemStyles };
export default React.memo(LargeMenuItem);
